import { OnInit, Component, ContentChild, Input, EventEmitter, TemplateRef, Output } from '@angular/core';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'topo-column',
  template: `
    <ng-content></ng-content>
  `,
  standalone: false
})
export class TopoTableColumnComponent implements OnInit {
  @Input() hasCheckbox: boolean;
  @Input() checkboxDisabled: boolean;
  @Input() isChecked: boolean;
  @Input() label: string;
  @Input() key: string;
  @Input() cellCssClass: string = null;
  @Input() cellStyle: string = null;
  @Input() headerCssClass: string = null;
  @Input() sortField: string = null;
  @ContentChild(TemplateRef, { static: false }) columnTemplate: TemplateRef<any>;

  readonly id = uuid(); // id for template tracking purposes

  constructor() {}

  ngOnInit(): void {}
}
